/**
 * Component: M60 Newsletter Cards
 * 
 */
'use strict';

import { FilterHelper } from '../filter-helper.js';

export class NewsletterCards
{
  constructor()
  {
    this.selectors = {
      component:        $('.c-v4-m60-newsletter-cards'),
      main:             $('.c-v4-m60-newsletter-cards--main'),
    };

    this.helper = new FilterHelper;
  }

  /**
   * Init
   * 
   */
  init()
  {
    if ( ! this.selectors.component.length ) return;

    this.helper.init_config({
      action:                    'sysdig_v4_filter__newsletter_cards',
      add_chip_on_active:        false,
      chips_taxonomy:            'year',
      component_id:              this.selectors.component.attr('id'),
      items_per_page:            15,
      items_per_row:             this.selectors.main.attr('data-per-row') || 3,
      paged:                     1,
      post_types:                [],
      remove_chip_on_deactivate: false,
      search_term:               '',
      terms:                     {},
      url:                       this.selectors.main.attr('data-url')
    });

    this.helper.init_target({
      target_container:   this.selectors.main,
      top:                this.selectors.main,
    });

    this.helper.init();
  }

}